/**
 * Created by AlexanderC on 6/10/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissingResourceException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when requested resource not found
 */
let MissingResourceException = exports.MissingResourceException = function (_Exception) {
  _inherits(MissingResourceException, _Exception);

  /**
   * @param {String} microserviceIdentifier
   * @param {String} resourceIdentifier
   */
  function MissingResourceException(microserviceIdentifier, resourceIdentifier) {
    _classCallCheck(this, MissingResourceException);

    return _possibleConstructorReturn(this, (MissingResourceException.__proto__ || Object.getPrototypeOf(MissingResourceException)).call(this, `Missing resource ${resourceIdentifier} in ${microserviceIdentifier}`));
  }

  return MissingResourceException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Exception/MissingResourceException.js
// module id = 413
// module chunks = 0